<style lang="scss" scoped>
.e-picker {
  right: unset !important;
  width: 20px;
}
</style>

<template>
  <div>
    <textarea
      class="form-control"
      ref="textMessageElementInput"
      :class="{ 'is-invalid': hasErrors }"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @keyup="setLastCursorPosition"
      @click="setLastCursorPosition"
    ></textarea>
    <div>
      <emoji-picker
        class="e-picker p-2"
        @select="addEmoji"
        v-tooltip:top="'Smileys/Emojis'"
      ></emoji-picker>
      <div @click="addContent('{sender-name}')" class="btn btn-secondary">
        Profilname Absender
      </div>
      <div @click="addContent('{sender-age}')" class="btn btn-secondary">
        Alter vom Absender
      </div>
      <div @click="addContent('{receiver-name}')" class="btn btn-secondary">
        Profilname Empfänger
      </div>
      <div @click="addContent('{receiver-age}')" class="btn btn-secondary">
        Alter vom Empfänger
      </div>
      <div
        @click="addContent('{sender-anonymous-plz}')"
        class="btn btn-secondary"
      >
        Anonymous PLZ Sender
      </div>
      <div @click="addContent('{sender-plz}')" class="btn btn-secondary">
        PLZ Sender
      </div>
      <div @click="addContent('{sender-city}')" class="btn btn-secondary">
        Ort Sender
      </div>
      <div
        @click="addContent('{receiver-anonymous-plz}')"
        class="btn btn-secondary"
      >
        Anonymous PLZ Empfänger
      </div>
      <div
        v-if="isSuperadmin"
        @click="addContent('{receiver-customer-id}')"
        class="btn btn-secondary"
      >
        CostumerID des Empfängers
      </div>
      <div @click="addContent('{currency}')" class="btn btn-secondary">
        Name der Währung
      </div>
    </div>
    <div
      v-for="(error, index) in attributeErrors"
      :key="index"
      class="invalid-feedback"
    >
      <div v-for="e in error" :key="e">
        {{ e }}
      </div>
    </div>
  </div>
</template>

<script lang="babel">
import EmojiPicker from "@/components/EmojiPicker.vue";
export default {
  components: {
    EmojiPicker
  },
  data() {
    return {
      lastCursorPosition: 0,
      message: "",
    }
  },
  props: {
    value: {
      required: true,
    },
    attributeErrors: {
      type: Array
    }
  },
  computed: {
    isSuperadmin() {
      return this.$store.getters["user/meHasPermissionTo"](
        "access_super_admin_area"
      );
    },
    hasErrors() {
      return this.attributeErrors !== null && this.attributeErrors.length !== 0;
    }
  },
  methods: {
    setLastCursorPosition(event) {
      this.lastCursorPosition = event.target.selectionStart;
    },
    addEmoji(event) {
      this.addContent(event.colons);
    },
    addContent(content) {
      if (!this.value || (this.lastCursorPosition > this.value.length) ) {
        this.lastCursorPosition = 0;
      }
      if( this.value && content ) {
        this.$refs.textMessageElementInput.value = this.value.substr(0,this.lastCursorPosition) + content + this.value.substr(this.lastCursorPosition);
        this.$refs.textMessageElementInput.focus();
        this.$refs.textMessageElementInput.selectionEnd = this.lastCursorPosition + content.length;
      } else {
        this.$refs.textMessageElementInput.value = content;
        this.$refs.textMessageElementInput.focus();
        this.$refs.textMessageElementInput.selectionEnd = this.lastCursorPosition + content.length;
      }
      this.$emit('input', this.$refs.textMessageElementInput.value);
    },
  }
}
</script>
